import React, { CSSProperties } from 'react';
import { Container, Box, ClassNameMap } from '@mui/material';
import { makeStyles  } from 'tss-react/mui';


const useConfigurationContainerStyles = makeStyles<Partial<FullscreenFormContainerProps>>({ name: 'FullscreenFormContainer' })(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(10),
    }
  },

  content: {
    maxWidth: '588px',
    width: '100%',
  },
}));


export type FullscreenFormContainerProps = {
  classes?: ClassNameMap<'container' | 'content'>;
  style?: CSSProperties;
};


export const FullscreenFormContainer: React.FC<FullscreenFormContainerProps> = (props) => {
  const { classes } = useConfigurationContainerStyles(props, { props });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className={classes.container} style={props.style}>
      <Box className={classes.content}>
        {props.children}
      </Box>
    </Container>
  );
};
